
import { Component, Vue, Watch } from "vue-property-decorator";
import { apiBaseConfig, apiBaseConfigEdit } from "@/api/setting";
import MaterialSelect from "@/components/material-select/index.vue";

@Component({
    components: {
        MaterialSelect,
    },
})
export default class Config extends Vue {
    /** S Data **/

    // เพิ่มข้อมูลแบบฟอร์มร้านค้า
    form: any = {
        platform_name: "", // บัญชี
        platform_ico: "", // รหัสผ่าน
        platform_login_image: "", // ยืนยันรหัสผ่าน
        document_status: 1 // 0-ซ่อน；1-แสดง；
    };

    // การตรวจสอบแบบฟอร์ม
    rules = {
        platform_name: [
            { required: true, message: "กรุณากรอกชื่อแพลตฟอร์ม", trigger: "blur" },
        ],
    };

    /** E Data **/

    /** S Methods **/
    // คลิกเพื่อส่งแบบฟอร์ม
    onSubmit(formName: string) {
        // ตรวจสอบว่ารูปแบบแบบฟอร์มถูกต้อง
        const refs = this.$refs[formName] as HTMLFormElement;
        refs.validate((valid: boolean): any => {
            if (!valid) return;

            this.handleBaseConfigEdit();
        });
    }

    // แก้ไขข้อมูลแพลตฟอร์ม
    async handleBaseConfigEdit(): Promise<void> {
        await apiBaseConfigEdit({ ...this.form });
        this.getBaseConfigFunc();
    }

    // รับรายละเอียด
    async getBaseConfigFunc(): Promise<void> {
        const res = await apiBaseConfig();
        for (var key in res) {
            this.$set(this.form, key, res[key]);
        }
    }

    /** E Methods **/

    /** S Life Cycle **/
    created() {
        this.getBaseConfigFunc();
    }
    /** E Life Cycle **/
}
